import { clickOn } from "../../events/click";
import { load } from "../../events/load";

const FORM_SELECTOR = "#contact-form, .reintegration-form form";
const FORM_SCROLL_TRIGGERS = [
    'a.btn.btn--primary[href="#"]',
    'a.btn.btn--secondary[href="#"]',
    'a.btn.btn--secondary[href="#cta"]',
    "a.cta__action-button",
];

const getNearestForm = (trigger) => {
    const forms = Array.from(document.querySelectorAll(FORM_SELECTOR));
    if (!forms.length) return null;

    const triggerRect = trigger.getBoundingClientRect();
    const triggerCenter = triggerRect.top + triggerRect.height / 2;

    let nearestForm = null;
    let minDistance = Number.POSITIVE_INFINITY;

    forms.forEach((form) => {
        const formRect = form.getBoundingClientRect();
        const formCenter = formRect.top + formRect.height / 2;
        const distance = Math.abs(formCenter - triggerCenter);

        if (distance < minDistance) {
            minDistance = distance;
            nearestForm = form;
        }
    });

    return nearestForm;
};

const initFormScroll = () => {
    clickOn(FORM_SCROLL_TRIGGERS, (event, trigger) => {
        const nearestForm = getNearestForm(trigger);
        if (!nearestForm) {
            const fallbackUrl = window.params?.contacts_page_url || "/contact/";
            window.location.href = fallbackUrl;
            return;
        }

        event.preventDefault();
        nearestForm.scrollIntoView({ behavior: "smooth", block: "start" });
    });
};

load(initFormScroll);


